//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Sizeable } from '@/mixins'

/**
 * KLoader is a helper component for any UI state where we need to indicate a loading state following
 * by showing some content.
 *
 * See /demo/loaders for examples
 */
export default {
  mixins: [
    Sizeable
  ],
  props: {
    /**
     * Value of the loading state. True means that the component is loading something and we should
     * show the spinner. False will show the slot content.
     */
    value: {
      type: Boolean,
      required: true,
    },
    /**
     * The default spinner colour
     */
    color: {
      type: String,
      default: 'brand-pink',
    }
  },
  data () {
    return {
      // Are we switching loading states currently (effects fade in)
      switchingState: false,
      // The timeout used to toggle the loading state changes (effects fade in)
      switchingStateTimeout: null,
    }
  },
  computed: {
    spinnerSize () {
      if (this.large) {
        return 98
      }
      if (this.small) {
        return 20
      }
      if (this.size) {
        return this.size
      }
      return 32
    },
    spinnerWidth () {
      if (this.large) {
        return 7
      }
      if (this.small) {
        return 2
      }
      if (this.width) {
        return this.width
      }
      return 4
    },
    verticalPadding () {
      if (this.large) {
        return 12
      }
      if (this.small) {
        return 2
      }
      return 5
    },
    classes () {
      return {
        'k-loader--loaded': !this.value,
        'k-loader--loading': this.value,
        'k-loader--switching-state': this.switchingState,
        ['py-' + this.verticalPadding]: this.value,
      }
    }
  },
  watch: {
    value () {
      // whenever value changes from the default state
      this.switchingState = true
      // we toggle the data here so it will toggle the loading state class
      // which handles the fade in effect for us
      clearTimeout(this.switchingStateTimeout)
      this.switchingStateTimeout = setTimeout(() => {
        this.switchingState = false
      }, 1000)
    }
  },
  destroyed () {
    clearTimeout(this.switchingStateTimeout)
  },
}
